import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyButtonGroupModule } from '@vendasta/galaxy/button-group';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

import { EmailEditorPreviewComponent } from './email-editor-preview.component';
import { TranslateModule } from '@ngx-translate/core';
import { EmailUII18nModule } from '../../src/lib/i18n/email-ui-i18n.module';

export { EmailEditorPreviewComponent };

export const MODULE_IMPORTS = [
  CommonModule,
  MatIconModule,
  MatButtonModule,
  GalaxyButtonGroupModule,
  GalaxyPipesModule,
  GalaxyLoadingSpinnerModule,
  TranslateModule,
  EmailUII18nModule,
];

export const MODULE_DECLARATIONS = [EmailEditorPreviewComponent];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: [EmailEditorPreviewComponent],
})
export class EmailEditorPreviewModule {}
